import React from 'react';

const ServiceDefinition: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="bg-[#F4B6A1]/10 p-4 rounded-lg mb-6">
        <p className="font-semibold text-gray-800">Important Notice:</p>
        <p>FeelHeard.me is an AI-powered emotional support service. While we strive to provide meaningful support, we are not a replacement for professional mental health services.</p>
      </div>

      <h4 className="text-lg font-semibold mb-2">Our Service Includes:</h4>
      
      <div className="mb-6">
        <h5 className="font-medium text-gray-800 mb-2">1. Text-Based Conversations</h5>
        <ul className="list-disc pl-5 space-y-2">
          <li>Real-time text chat with our AI companion</li>
          <li>Natural language processing for authentic interactions</li>
          <li>Asynchronous messaging for flexibility</li>
          <li>Message history and context awareness</li>
        </ul>
      </div>

      <div className="mb-6">
        <h5 className="font-medium text-gray-800 mb-2">2. Voice Interactions</h5>
        <ul className="list-disc pl-5 space-y-2">
          <li>Speech-to-text for natural conversation flow</li>
          <li>Text-to-speech with emotion-aware responses</li>
          <li>Optimized voice quality for clarity</li>
        </ul>
      </div>

      <div className="mb-6">
        <h5 className="font-medium text-gray-800 mb-2">3. Core Features</h5>
        <ul className="list-disc pl-5 space-y-2">
          <li>24/7 availability for support</li>
          <li>Emotional pattern recognition</li>
          <li>Personalized conversation style</li>
          <li>Progress tracking and insights</li>
          <li>Secure data encryption</li>
        </ul>
      </div>

      <h4 className="text-lg font-semibold mb-2 mt-6">Service Limitations:</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Not a crisis intervention service</li>
        <li>Not a substitute for professional therapy or counseling</li>
        <li>Cannot prescribe medications or provide medical advice</li>
        <li>May experience occasional maintenance downtimes</li>
        <li>Voice quality may vary based on connection</li>
      </ul>

      <div className="bg-[#C2A4D6]/10 p-4 rounded-lg mt-6">
        <p className="text-sm text-gray-600">
          Both text and voice interactions maintain consistent AI capabilities, knowledge base access, 
          and service quality while adhering to our established security and privacy protocols.
        </p>
      </div>
    </div>
  );
};

export default ServiceDefinition;